import { config } from "../../../config/domain";
import deviceName from "../../utils/deviceName";
import { getAccData } from "../login/loginService";
import {
  DownloadEsignDocument,
  downloadPrefilledNominatinForm,
  esignDownloadJMW,
  esignUrlJMW,
  GetEsignUrl,
  getMemorandumDetails,
  GetPreFilledFormPDF,
  updateAccReactStatus,
} from "../serviceRequest/srApiService";
import { useQuery } from "../urlHelper";
import * as esignService from "../../service/esign/esignService";

var prefilledFormTypes = [
  {
    type: "bank",
    name: "BankPreFilledPDF",
  },
  {
    type: "address",
    name: "AddressPreFilledPDF",
  },
  {
    type: "emailMob",
    name: "Email&MobilePDF",
  },
  {
    type: "accReact",
    name: "AccountReactivationPreFilledPDF",
  },
  {
    type: "nomination",
    name: "NomineePreFilledPDF",
  },
  {
    type: "accClosure",
    name: "Online Closure Request",
  },
  {
    type: "ddpi",
    name: "Online DDPI enablement",
  },
];
const device = deviceName();

export const proceedToEsign = async (
  serReqId: any,
  type: string,
  downloadPrefilledForm?: boolean
) => {
  try {
    // console.log(device);
    let prefillFormpdfRes = await getPreFilledFormPDF(serReqId, type);

    if (prefillFormpdfRes) {
      if (downloadPrefilledForm) base64toPDF(prefillFormpdfRes);
      return await getEsignUrl(prefillFormpdfRes, serReqId, type);
    } else handleError();
  } catch (err) {
    handleError();
  }
};
export const getEsignUrl = async (base64Data: any, appId: any, type: any) => {
  try {
    const esignRes = await GetEsignUrl({
      ApplicationId: String(appId),
      Base64Document: base64Data,
      ReturnURL: `${config.root
        }app/clientarea/service-request?mod=${type}&source=${window.location.href.includes("source=ajs") ? "nsdl_ajs" : "nsdl_onep"
        }&appID=${btoa(appId)}`,
    });
    if (esignRes.Code === 200) {
      let esignUrl = esignRes.Data && esignRes.Data.HolderDetails && esignRes.Data.HolderDetails.length > 0 && esignRes.Data.HolderDetails[0].SignUrl ? esignRes.Data.HolderDetails[0].SignUrl : ""
      if (esignUrl) {
        window.open(esignUrl, "_self");
        return true;
      }
      else handleError()
    } else handleError();
  } catch (err) {
    handleError();
  }
};

const handleError = () => {
  return false;
};
export const base64toPDF = (respData: any, fileName?: any) => {
  var decodedPdfContent = atob(respData);
  var byteArray = new Uint8Array(decodedPdfContent.length);
  for (var i = 0; i < decodedPdfContent.length; i++) {
    byteArray[i] = decodedPdfContent.charCodeAt(i);
  }
  var blob = new Blob([byteArray.buffer], { type: "application/pdf" });
  var _pdfurl = URL.createObjectURL(blob);
  if (device === "iPhone") {
    window.open(_pdfurl, "_blank");
  } else {
    var link = document.createElement("a");
    document.body.appendChild(link);
    link.href = _pdfurl;
    link.download = fileName ? fileName + ".pdf" : "PrefilledForm.pdf";
    var evt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false,
    });
    link.dispatchEvent(evt);
    window.URL.revokeObjectURL(_pdfurl);
    link.remove();
  }
};
export const getPreFilledFormPDF = async (serReqId: any, type: string) => {
  try {
    const res = await GetPreFilledFormPDF({
      preFilledFormName: prefilledFormTypes.filter((ele: any) => {
        return ele.type === type;
      })[0].name,
      parentServiceId: serReqId,
    });

    if (res) {
      return res;
    } else handleError();
  } catch (err) {
    handleError();
  }
};

// Get pre-filled form for nomination 
export const getPreFilledFormNomination = async (serReqId: string) => {
  try {
    // const res = await downloadPrefilledNominatinForm(serReqId);
    const res = await esignService.getPreFilledFormPDF(
            serReqId,
            "nomination"
          );

    if (res) {
      return res;
    } else handleError();
  } catch (err) {
    handleError();
  }
};
export const downloadEsignDocument = async (appId: any, source: any) => {
  try {
    const downEsignDocRes = await DownloadEsignDocument({
      ApplicationId: appId,
    });
    if (downEsignDocRes && downEsignDocRes.Status === "SUCCESS") {
      return downEsignDocRes.Base64Document;
    } else{
      window.location.href = source === "nsdl_onep"
      ? config.onePlatformBase + "service-request"
      : config.rootUrl + "clientarea/servicerequest";
    }
  } catch (err) {
    window.location.href = source === "nsdl_onep"
    ? config.onePlatformBase + "service-request"
    : config.rootUrl + "clientarea/servicerequest";
  }
};
export const downloadEsignDocumentV2 = async (appId: any, source: any) => {
  try {
    const downEsignDocRes = await DownloadEsignDocument(appId);
    // console.log('downEsignDocRes', downEsignDocRes);
    if (downEsignDocRes.Data.Base64Document)
      return downEsignDocRes.Data.Base64Document;
    else {
      window.location.href = source === "nsdl_onep"
      ? config.onePlatformBase + "service-request"
      : config.rootUrl + "clientarea/servicerequest";
    }
  } catch (err) {
    window.location.href = source === "nsdl_onep"
    ? config.onePlatformBase + "service-request"
    : config.rootUrl + "clientarea/servicerequest";
  }
};

export const getEsignUrlJMW = async (
  base64Data: any,
  appId: any,
  type: any
) => {
  try {
    const RedirectnSource = window.localStorage.getItem("source");
    const esignUrl = await esignUrlJMW({
      id: appId,
      data: base64Data,
      successUrl: `${
          config.root
        }app/clientarea/service-request?mod=${type}&source=${
          window.location.href.includes("source=ajs") ? "nsdl_ajs" : "nsdl_onep"
        }&appID=${btoa(appId)}`,
      failUrl: RedirectnSource == "onep-sr" 
        ? config.onePlatformBase + "service-request" 
        : config.rootUrl + "clientarea/servicerequest",
      accTyp: getAccData("accTyp"),
      sr: prefilledFormTypes.find((x) => x.type === type)?.name,
    });
    if (esignUrl && esignUrl.data) {
      window.open(esignUrl.data.url, "_self");
      return true;
    } else handleError();
  } catch (err) {
    handleError();
  }
};
export const getEsignUrlJMWV2 = async (
  base64Data: any,
  appId: any,
  type: any
) => {
  try {
    const esignUrl = await esignUrlJMW({
      id: appId,
      returnUrl: `${config.root
        }app/clientarea/service-request?mod=${type}&source=${window.location.href.includes("source=ajs") ? "nsdl_ajs" : "nsdl_onep"
        }&appID=${btoa(appId)}`,
        accTyp: (getAccData("accTyp") && getAccData("accTyp") === "COMEQ")
        ? "EQ"
        : getAccData("accTyp"),
      sr: prefilledFormTypes.find((x) => x.type === type)?.name,
    });
    // console.log('esignUrl', esignUrl);
    if (esignUrl && esignUrl.data) {
      let esignRedirectUrl = JSON.parse(esignUrl.data.url).Data.HolderDetails[0].SignUrl
      if (esignRedirectUrl) {
        window.open(esignRedirectUrl, "_self");
        return true;
      }
      else handleError();

    } else handleError();
  } catch (err) {
    handleError();
  }
};

export const downloadEsignDocJMW = async (appId: any, source: any) => {
  try {
    const downEsignDocRes = await esignDownloadJMW(appId);
    if (downEsignDocRes && downEsignDocRes.data) {
      return downEsignDocRes.data.data;
    } else {
      window.location.href = source === "nsdl_onep"
      ? config.onePlatformBase + "service-request"
      : config.rootUrl + "clientarea/servicerequest";
    }
  } catch (err) {
    window.location.href = source === "nsdl_onep"
    ? config.onePlatformBase + "service-request"
    : config.rootUrl + "clientarea/servicerequest";
  }
};